// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
li[data-v-2958490c] {
    position: relative;
    padding-left: calc(36px + 1rem);
    margin-bottom: 2rem;
    clear: both;
    counter-increment: instruction-counter;
    cursor: pointer;
    white-space: pre-line;
}
li[data-v-2958490c]::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 36px;
    border: 1px solid var(--color-border-dark);
    border-radius: 50%;
    background-color: var(--color-background-dark);
    background-position: center;
    background-repeat: no-repeat;
    content: counter(instruction-counter);
    line-height: 36px;
    outline: none;
    text-align: center;
}
li[data-v-2958490c]:hover::before {
    border-color: var(--color-primary-element);
}
.done[data-v-2958490c]::before {
    content: '✔';
}
li span[data-v-2958490c],
li input[type='checkbox'][data-v-2958490c] {
    display: inline-block;
    width: 1rem;
    height: auto;
    padding: 0;
    margin: 0 0.5rem 0 0;
    line-height: 1rem;
    vertical-align: middle;
}
.markdown-instruction[data-v-2958490c] ol > li {
    list-style-type: numbered;
}
.markdown-instruction[data-v-2958490c] ul > li {
    list-style-type: disc;
}
.markdown-instruction[data-v-2958490c] ol > li,
.markdown-instruction[data-v-2958490c] ul > li {
    margin-left: 20px;
}
.markdown-instruction[data-v-2958490c] a {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeView/RecipeInstruction.vue"],"names":[],"mappings":";AAmCA;IACA,kBAAA;IACA,+BAAA;IACA,mBAAA;IACA,WAAA;IACA,sCAAA;IACA,eAAA;IACA,qBAAA;AACA;AAEA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,0CAAA;IACA,kBAAA;IACA,8CAAA;IACA,2BAAA;IACA,4BAAA;IACA,qCAAA;IACA,iBAAA;IACA,aAAA;IACA,kBAAA;AACA;AAEA;IACA,0CAAA;AACA;AAEA;IACA,YAAA;AACA;AAEA;;IAEA,qBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,oBAAA;IACA,iBAAA;IACA,sBAAA;AACA;AAEA;IACA,yBAAA;AACA;AAEA;IACA,qBAAA;AACA;AAEA;;IAEA,iBAAA;AACA;AAEA;IACA,0BAAA;AACA","sourcesContent":["<template>\n    <li :class=\"{ done: isDone }\" @click=\"toggleDone\">\n        <VueShowdown :markdown=\"instruction\" class=\"markdown-instruction\" />\n    </li>\n</template>\n\n<script setup>\nimport { ref } from 'vue';\n\ndefineProps({\n    /* Instruction HTML string to display. Content should be sanitized.\n     */\n    instruction: {\n        type: String,\n        default: '',\n    },\n});\n\n/**\n * @type {import('vue').Ref<boolean>}\n */\nconst isDone = ref(false);\n\nconst toggleDone = () => {\n    isDone.value = !isDone.value;\n};\n</script>\n\n<script>\nexport default {\n    name: 'RecipeInstruction',\n};\n</script>\n\n<style scoped>\nli {\n    position: relative;\n    padding-left: calc(36px + 1rem);\n    margin-bottom: 2rem;\n    clear: both;\n    counter-increment: instruction-counter;\n    cursor: pointer;\n    white-space: pre-line;\n}\n\nli::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 36px;\n    height: 36px;\n    border: 1px solid var(--color-border-dark);\n    border-radius: 50%;\n    background-color: var(--color-background-dark);\n    background-position: center;\n    background-repeat: no-repeat;\n    content: counter(instruction-counter);\n    line-height: 36px;\n    outline: none;\n    text-align: center;\n}\n\nli:hover::before {\n    border-color: var(--color-primary-element);\n}\n\n.done::before {\n    content: '✔';\n}\n\nli span,\nli input[type='checkbox'] {\n    display: inline-block;\n    width: 1rem;\n    height: auto;\n    padding: 0;\n    margin: 0 0.5rem 0 0;\n    line-height: 1rem;\n    vertical-align: middle;\n}\n\n.markdown-instruction:deep(ol > li) {\n    list-style-type: numbered;\n}\n\n.markdown-instruction:deep(ul > li) {\n    list-style-type: disc;\n}\n\n.markdown-instruction:deep(ol > li),\n.markdown-instruction:deep(ul > li) {\n    margin-left: 20px;\n}\n\n.markdown-instruction:deep(a) {\n    text-decoration: underline;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
